import { render, staticRenderFns } from "./RankingSubOrgao.vue?vue&type=template&id=56f35d58&scoped=true&"
import script from "./RankingSubOrgao.vue?vue&type=script&lang=js&"
export * from "./RankingSubOrgao.vue?vue&type=script&lang=js&"
import style0 from "./RankingSubOrgao.vue?vue&type=style&index=0&id=56f35d58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f35d58",
  null
  
)

export default component.exports